import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";
import "../Dashboard/Dashboard.scss";
import LiveData from "../Dashboard/LiveData";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);
const EmtLoadDetails = () => {
  return (
    <div>
      <LiveData />
    </div>
  );
};

export default EmtLoadDetails;

// -------------------

// // EmtLoadDetails.js
// import React, { useState } from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   TimeScale,
// } from "chart.js";
// import "chartjs-adapter-date-fns";
// import "../Dashboard/Dashboard.scss";
// import LiveData from "../Dashboard/LiveData";
// import { RiRefreshLine } from "react-icons/ri";

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);

// const EmtLoadDetails = () => {
//   const [refetchLiveData, setRefetchLiveData] = useState(null);

//   const handleRefresh = () => {
//     if (refetchLiveData) {
//       console.log("Refetching data from EmtLoadDetails...");
//       refetchLiveData();
//     }
//   };

//   return (
//     <div>
//       <LiveData onRefetch={setRefetchLiveData} />
//     </div>
//   );
// };

// export default EmtLoadDetails;


